import {Button, DialogActions, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {Product, ProductUpdateMeta, ProductUpdateMetaItem} from "../../../../api/Products";
import {RenderStringCol, Table} from "../../../../misc/scroller/Table";
import {projectLabel} from "../../../../api/Projects";
import useWindowSize from "react-use/lib/useWindowSize";
import {useMemo} from "react";

export function ProductUpdateMetaReview(props: {
    product: Product;
    value: ProductUpdateMeta;

    onCancel(): void;
    onDone(): void;
}) {
    const win = useWindowSize();

    const data = useMemo(() => {
        let result: Item[] = [];
        let itemId = 0;

        const v = props.value;
        if(v.updated && v.updated.length > 0) {
            result.push({
                id: itemId++,
                label: "Successfully Updated",
                items: props.value.updated || [],
            });
        }

        if(v.skippedQuoteBecauseProjectModeChanged && v.skippedQuoteBecauseProjectModeChanged.length > 0) {
            result.push({
                id: itemId++,
                label: "Project no longer in quote mode (skipped quote items)",
                items: props.value.skippedQuoteBecauseProjectModeChanged || [],
            });
        }

        if(v.skippedBecauseProjectModeNotActive && v.skippedBecauseProjectModeNotActive.length > 0) {
            result.push({
                id: itemId++,
                label: "Project mode not active (skipped)",
                items: props.value.skippedBecauseProjectModeNotActive || [],
            });
        }

        if(v.skippedBecauseProjectArchived && v.skippedBecauseProjectArchived.length > 0) {
            result.push({
                id: itemId++,
                label: "Project archived (skipped)",
                items: props.value.skippedBecauseProjectArchived || [],
            });
        }

        if(v.skippedBecauseDelivered && v.skippedBecauseDelivered.length > 0) {
            result.push({
                id: itemId++,
                label: "Items delivered (skipped)",
                items: props.value.skippedBecauseDelivered || [],
            });
        }

        if(v.skippedBecauseOrdered && v.skippedBecauseOrdered.length > 0) {
            result.push({
                id: itemId++,
                label: "Items ordered (skipped)",
                items: props.value.skippedBecauseOrdered || [],
            });
        }

        return result;
    }, [props.value]);

    return (
        <Dialog2 open>
            <DialogTitle>
                {props.product.name || props.product.categoryName} ({props.product.productCode}) Update Results
            </DialogTitle>
            <div style={{minHeight: win.height * 0.75, display: "flex", flexDirection: "column"}}>
                <Table<Item>
                    name="product-update-meta-review"
                    columns={[
                        RenderStringCol("", v => "", 20),
                        RenderStringCol<Item>("Label", v => v.label, 600),
                    ]}
                    childTableData={d => d.items}
                    childTableColumns={() => [
                        RenderStringCol<ProductUpdateMetaItem>("Project", d => projectLabel({projectNumber: d.projectNumber, name: d.projectName}), 250),
                        RenderStringCol<ProductUpdateMetaItem>("Openings", d => d.openings.join(", "), 300),
                    ]}
                    childTableDeps={[data]}
                    fetch={() => Promise.resolve(data)}
                    fetchDeps={[data]}
                />
            </div>

            <DialogActions>
                <Button onClick={() => props.onCancel()}>Go Back</Button>
                <Button onClick={() => props.onDone()}>Done</Button>
            </DialogActions>
        </Dialog2>
    )
}

type Item = {
    id: number;
    items: ProductUpdateMetaItem[];
    label: string;
}